import Swiper from "swiper";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

export function list_swiper() {

    let _slides = 4;
    const $swiper = '.list_swiper';

    const mySwiper = new Swiper($swiper + ' .swiper', {
        modules: [Pagination, Navigation, Autoplay],
        grabCursor: true,
        slidesPerView: _slides,
        slidesPerGroup: _slides,
        // loop: true,
        // loopedSlides: _slides,
        speed: 600,
        pagination: {
            el: $swiper + ' .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: $swiper + ' .swiper-button-next',
            prevEl: $swiper + ' .swiper-button-prev',
        },
        a11y: {
            enabled: true,
            firstSlideMessage: "第一則",
            lastSlideMessage: "最後一則",
            paginationBulletMessage: "到第 {{index}} 則",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            960: {
                slidesPerView: _slides,
            }
        }
    });
};